module.exports = __webpack_public_path__ + "img/bl.39920acf.svg";